export const Navbar = () => {
  return (
    <div className="navbar">
      <div className="navbar-content px-5">
        <p className="text-white text-xl">
          Brought to you by&nbsp;
          <a className="font-bold underline decoration-solid decoration-1" target="_blank" href="https://wagwalking.com" rel="noreferrer">
            Wag!
          </a>
          .
        </p>
      </div>
      <hr />
    </div>
  )
}
